import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cce8362"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asahi-input"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "type", "value", "readonly", "disabled", "maxlength", "placeholder"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "disable-wrapper w-100"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bold fs-14" }
const _hoisted_9 = {
  key: 0,
  class: "fw-normal text-uppercase subtitle-label fs-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.disableShipToAddress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: _ctx.id
            }, _toDisplayString(_ctx.label), 9, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["wrapper w-100", {isCreateTicket: _ctx.isCreateTicket}])
        }, [
          _createElementVNode("input", {
            id: _ctx.id,
            type: _ctx.type,
            value: _ctx.value,
            readonly: _ctx.readonly,
            disabled: _ctx.disabled,
            maxlength: _ctx.maxlength,
            placeholder: _ctx.placeholder,
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
            class: _normalizeClass([{ invalid: _ctx.invalid, 'rounded-pill': _ctx.roundedPill, 'icon-gap': _ctx.icon, 'placeholder-bold': _ctx.placeholderClass === 'subtitle-bold', 'has-value': _ctx.value, 'bold-input': _ctx.inputBold, 'disabled-input': _ctx.disabled }, "input-element"])
          }, null, 42, _hoisted_3),
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.icon,
                alt: "icon",
                class: "icon"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", null, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.icon,
                alt: "icon",
                class: "icon"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.value), 1),
          (_ctx.subTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.subTitle), 1))
            : _createCommentVNode("", true)
        ])
      ]))
}